import SubHeader from "../../components/header/SubHeader";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchProductAlert, manageProduct, resetProductManageStatus} from "../../store/product-slice";
import {useNavigate} from "react-router-dom";
import {
    getStockEditableTableColumns,
    getStockEditableTableData
} from "../../models/productModel";
import TableEdit from "../../components/common/table/TableEdit";
import AlertMessage from "../../components/ui/AlertMessage";

const ProductStockAlert = () => {
    const dispatch = useDispatch();
    const navigator = useNavigate();
    const [alertInfo, setAlertInfo] = useState(null);
    const {
        productAlert: items,
        fetchProductAlertStatus,
        productManageStatus,
        pagination,
        error
    } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchProductAlert({
            ...userRole,
        }));
    }, [dispatch, userRole]);

    useEffect(() => {
        if (productManageStatus === "success") {
            setAlertInfo({
                message: "Products have been updated successfully.",
                variant: "success",
            });
            dispatch(resetProductManageStatus());

            //Relaod the page after the changes
            setTimeout(() => {
                window.location.reload();
            }, 1000); // give alert half second to display
        }
    }, [dispatch, productManageStatus, navigator]);

    const submitHandler = (data) => {
        if (!data || data.length === 0) {
            setAlertInfo({
                message: "No changes in price or stock/Stock Threshold.",
                variant: "warning",
            });
            return;
        }

        const updatedData = {
            id: userRole.scopeId,
            products: [...data],
        }
        dispatch(manageProduct({...userRole, data: updatedData}));
    }

    const tableColumns = getStockEditableTableColumns();
    const tableData = getStockEditableTableData({items});

    return (
        <>
            <SubHeader title="Stock Alert"/>
            {fetchProductAlertStatus === "loading" && <p>Loading...</p>}
            {(fetchProductAlertStatus === "failed" || productManageStatus === "failed") &&
                <h6 className="text-danger">{error}</h6>}
            {fetchProductAlertStatus === "success" &&
                <>
                    <div className="d-flex justify-content-end fs-md"><span className="text-secondary">Total Items:</span><span
                        className="text-primary ms-1">{pagination?.count}</span></div>
                    <div className="container p-0 ms-0">
                        <TableEdit className="mobile-responsive mt-4" columns={tableColumns} data={tableData}
                                   onSubmitChanges={submitHandler}
                                   idField="productId"
                        />
                    </div>
                </>
            }
            {alertInfo && (
                <AlertMessage
                    message={alertInfo.message}
                    variant={alertInfo.variant}
                    duration={2000}
                    onClose={() => setAlertInfo(null)}
                />
            )}
        </>
    )
}

export default ProductStockAlert;